import * as React from 'react';
import * as style from './SearchModalSuggestionCard.css';
import { ISuggestionItem } from '../../../../types/suggestions';

export interface ISearchModalSuggestionCardProps {
  suggestion: ISuggestionItem;
  onClick: (suggestion: ISuggestionItem) => void;
}

export const SearchModalSuggestionCard: React.FC<ISearchModalSuggestionCardProps> = props => {
  const { suggestion, onClick } = props;
  const {
    suggestion: { title, subtitle, imageUrl },
  } = props;

  const handleClick = React.useCallback(() => {
    onClick(suggestion);
  }, [onClick, suggestion]);

  return (
    <div className={style['container']} onClick={handleClick}>
      <div className={style['image']} style={{ backgroundImage: `url(${imageUrl})` }} />
      <div className={style['text']}>{title}</div>
      <div className={style['description']}>{subtitle}</div>
    </div>
  );
};
